/**
 * Name: DELETE CUSTOMER SCHEDULE
 * Author: @Gaurav
 * Date: 23-07-2021
 */
export default function reducer(
  state = {
    status: 'uninitiated',
    result: [],
  },
  action
) {
  switch (action.type) {
    case 'DELETE_CUSTOMER_SCHEDULE_INITIATED': {
      return { ...state, status: 'initiated' };
    }
    case 'DELETE_CUSTOMER_SCHEDULE_SUCCESS': {
      return { ...state, status: 'success', result: action.payload };
    }
    case 'DELETE_CUSTOMER_SCHEDULE_FAILED': {
      return { ...state, status: 'failed', result: action.payload };
    }
    default: {
      return state;
    }
  }
}
